<template>
    <div class="component-rounded-image">
        <div class="rounded-image">
            <CmsImage
                :data="data.roundedImage"
                fit="cover"
            />
        </div>

        <div class="rounded-image-background">
            <CmsImage
                v-if="data.backgroundImage"
                :data="data.backgroundImage"
                :is-eager="hasEagerImage"
                fit="cover"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ComponentRoundedImageFragment } from '@/graphql/api'
import { cmsColorToButtonColor } from '@/components/cms'

import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    data: ComponentRoundedImageFragment
    hasEagerImage?: boolean
}>()

const topBackgroundColor = computed(() =>
    cmsColorToButtonColor(props.data.backgroundColor)
)

const bottomBackgroundColor = computed(() =>
    cmsColorToButtonColor(props.data.backgroundImageColor)
)
</script>

<style lang="scss" scoped>
.component-rounded-image {
    background-color: v-bind(topBackgroundColor);

    .rounded-image {
        width: 335px;
        max-width: 100%;
        height: 500px;
        border-radius: 200px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        position: relative;
        z-index: 2;
        margin: 0 auto -270px;

        @include min-width(1024) {
            margin-bottom: -350px;
        }
    }

    .rounded-image-background {
        width: 100%;
        height: 370px;
        background-color: v-bind(bottomBackgroundColor);
        background-repeat: no-repeat;
        background-position: center center;

        @include min-width(768) {
            background-size: cover;
        }

        @include min-width(1024) {
            height: 430px;
        }
    }
}
</style>
